module.exports = __webpack_public_path__ + "static/lighthouse-4.ef10a6fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/lighthouse-4.jpg
// module id = 496
// module chunks = 249938909357035